import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Reveal from "../components/Reveal";
import { useI18n } from "../i18n/I18nProvider";

const IMG_1 = "/generated/founder_director_monitor.jpg";
const IMG_2 = "/generated/founder_photo_session.jpg";

export default function About() {
  const { t } = useI18n();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["8%", "-8%"]);

  return (
    <section id="studio" ref={ref} className="py-32 lg:py-40 bg-[#050505]" data-testid="home-about">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 relative grid grid-cols-2 gap-4">
            <motion.div style={{ y: y1 }} className="aspect-[3/4] overflow-hidden">
              <img src={IMG_1} alt="Phaneroo studio founder" className="w-full h-full object-cover saturate-[0.85]" loading="lazy" />
            </motion.div>
            <motion.div style={{ y: y2 }} className="aspect-[3/4] mt-12 overflow-hidden">
              <img src={IMG_2} alt="Phaneroo studio at work" className="w-full h-full object-cover saturate-[0.85]" loading="lazy" />
            </motion.div>
          </div>

          <div className="lg:col-span-7">
            <Reveal>
              <div className="flex items-center gap-3 text-[11px] tracking-[0.28em] uppercase text-ink-300">
                <span className="block w-8 h-px bg-rouge" /><span>{t.about.eyebrow}</span>
              </div>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-6 font-serif-editorial text-4xl sm:text-5xl lg:text-6xl text-ink-100 tracking-tight leading-[1.05] max-w-2xl">
                {t.about.title}
              </h2>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-10 text-ink-300 text-base lg:text-lg leading-relaxed max-w-xl">{t.about.p1}</p>
            </Reveal>
            <Reveal delay={0.22}>
              <p className="mt-6 text-ink-300 text-base lg:text-lg leading-relaxed max-w-xl">{t.about.p2}</p>
            </Reveal>
            <Reveal delay={0.28}>
              <ul className="mt-10 space-y-3 max-w-md">
                {t.about.bullets.map((b) => (
                  <li key={b} className="flex items-center gap-4 text-[13px] tracking-wide text-ink-100 border-b border-hair pb-3">
                    <span className="text-rouge font-serif-editorial">—</span>{b}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
